import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ChecklistAccordionComponent } from '@app/components';
import { ChecklistAccordionGroup } from '@app/interfaces';
import { CustomReportQuery } from '@app/models/reporting/custom-report-query.model';
import { BaseForm } from '@app/modules/forms/base.form';
import { CustomReportColumn } from '@app/modules/reporting/interfaces/custom-report-column.interface';
import { convertToChecklistAccordionGroup } from './functions/convert-to-checklist-accordion-group.function';

const createColumn = (): CustomReportColumn => {
    const emptyColumn: CustomReportColumn = {
        group: '',
        values: [],
    };

    return emptyColumn;
};

const filterGroupsWithOptions = (column: ChecklistAccordionGroup) => column.options.some((option) => option.checked);

@Component({
    selector: 'app-custom-report-information',
    templateUrl: './custom-report-information.form.html',
    styleUrls: ['./custom-report-information.style.scss'],
})
export class CustomReportInformationForm extends BaseForm implements OnInit {
    @Input() customReportQuery: CustomReportQuery;

    @ViewChild('checklistAccordion', { static: true })
    checklistAccordion: ChecklistAccordionComponent;

    isLoading = true;

    allColumns: ChecklistAccordionGroup[] = [];
    reportName: string;

    constructor() {
        super();
        this.getColumns();
    }

    ngOnInit(): void {
        if (this.customReportQuery.name) {
            this.reportName = this.customReportQuery.name;
        }
    }

    getSelectedColumns(): CustomReportColumn[] {
        return this.allColumns
            .filter((colum) => filterGroupsWithOptions(colum))
            .map((column) => {
                const selectedColumn = createColumn();

                selectedColumn.group = column.group;
                selectedColumn.values = column.options.filter((option) => option.checked).map((option) => option.value);

                return selectedColumn;
            });
    }

    private setSelectedColumns(): void {
        this.customReportQuery.columns.forEach((initialColumn) => {
            initialColumn.values.forEach((value) => {
                const selectedColumn = this.allColumns.find((column) => column.group === initialColumn.group);

                if (!selectedColumn) {
                    return;
                }
                const selectedOption = selectedColumn.options.find((option) => option.value === value);

                if (!selectedOption) {
                    return;
                }
                selectedOption.checked = true;
            });
        });
    }

    private getColumns(): void {
        const customReportQuery: CustomReportQuery = new CustomReportQuery();
        customReportQuery
            .getColumns()
            .then((customReportColumns) => {
                this.allColumns = convertToChecklistAccordionGroup(customReportColumns.data);

                if (this.customReportQuery.columns) {
                    this.setSelectedColumns();
                }

                this.isLoading = false;
            })
            .catch(() => (this.isLoading = false));
    }
}
